import axios from 'axios'
import defaultSettings from '@/config/defaultSettings'
import TokenCache from '@/utils/cache/TokenCache'
import moment from 'moment'
var uuid = require('node-uuid')
var md5 = require('md5')
const createServices = async () => {
  try {
    // 加载环境配置
    const response = await fetch('/env.json')
    if (!response.ok) throw new Error('环境配置加载失败')
    const env = await response.json()

    // 创建移交后服务实例
    const http = axios.create({
      baseURL: env.LocalRootUrl,
      timeout: env.apiTimeout,
    })

    // 创建移交前服务实例
    const httpBefore = axios.create({
      baseURL: env.BeforeLocalRootUrl,
      timeout: env.apiTimeout,
    })
    let rootUrl = env.LocalRootUrl
    let rootUrlBefore = env.BeforeLocalRootUrl
    let ProjectId = env.ProjectId
    // 公共请求拦截器
    const setupInterceptors = (instance) => {
      instance.interceptors.request.use(
        (config) => {
          // 可添加全局请求处理逻辑
          // CheckSign签名检验
          const appId = defaultSettings.appId
          const appSecret = defaultSettings.appSecret
          const guid = uuid.v4()
          const time = moment().format('YYYY-MM-DD HH:mm:ss')
          let body = ''
          if (config.data) {
            body = JSON.stringify(config.data)
          }
          const sign = md5(appId + time + guid + body + appSecret)

          config.headers.appId = appId
          config.headers.time = time
          config.headers.guid = guid
          config.headers.sign = sign

          // 携带token
          if (TokenCache.getToken()) {
            config.headers.Authorization = 'Bearer ' + TokenCache.getToken()
          }
          return config
        },
        (erroror) => {
          console.log(erroror, 'erroror')
          return Promise.reject(erroror)
        }
      )

      instance.interceptors.response.use(
        (res) => {
          return res.data
        },
        (error) => {
          console.log(error)
          if (error && error.code == 'ERR_NETWORK') {
            return Promise.resolve({
              Success: false,
              Msg: '当前系统升级或服务器网络异常，请稍后重试',
            })
          }
          if (error && error.response) {
            console.log(error, 'error')
            switch (error.response.status) {
              case 400:
                error.message = '请求错误'
                break

              case 401:
                error.message = '未授权，请登录'
                TokenCache.deleteToken()
                // location.href = "/";
                location.reload()
                break

              case 403:
                error.message = '拒绝访问'
                break

              case 404:
                error.message = `请求地址出错: ${error.response.config.url}`
                break

              case 408:
                error.message = '请求超时'
                break

              case 500:
                error.message = '服务器内部错误'
                break

              case 501:
                error.message = '服务未实现'
                break

              case 502:
                error.message = '网关错误'
                break

              case 503:
                error.message = '服务不可用'
                break

              case 504:
                error.message = '网关超时'
                break

              case 505:
                error.message = 'HTTP版本不受支持'
                break

              default:
            }
          }
          return Promise.resolve({ Success: false, Msg: error.message })
        }
      )
    }

    // 为两个实例添加拦截器
    setupInterceptors(http)
    setupInterceptors(httpBefore)

    return { http, httpBefore, rootUrl, rootUrlBefore, ProjectId }
  } catch (error) {
    console.error('使用备用配置', error)
    //备用配置暂无
    return {
      httpBefore: axios.create({ baseURL: '' }),
      rootUrl: '',
      rootUrlBefore: '',
      ProjectId: '',
      http: axios.create({ baseURL: '' }),
    }
  }
}

export default createServices()
